import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface Integration {
  id: number;
  configurations: Record<string, any>;
  integration_type: string;
  state: string;
}

interface IntegrationsState {
  data: Integration[];
  loading: boolean;
  error: string | null;
  activating: string | null; // Track which platform is being activated
}

const initialState: IntegrationsState = {
  data: [],
  loading: false,
  error: null,
  activating: null,
};

const integrationsSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    // Fetch integrations
    fetchIntegrationsRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchIntegrationsSuccess: (state, action: PayloadAction<Integration[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchIntegrationsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    // Activate integration (OAuth flow)
    activateIntegrationRequest: (
      state,
      action: PayloadAction<{ platform: string; restaurantId: string }>
    ) => {
      state.activating = action.payload.platform;
      state.error = null;
    },
    activateIntegrationSuccess: (state) => {
      state.activating = null;
      state.error = null;
    },
    activateIntegrationFailure: (state, action: PayloadAction<string>) => {
      state.activating = null;
      state.error = action.payload;
    },
    
    // Deactivate integration
    deactivateIntegrationRequest: (
      state,
      action: PayloadAction<{ restaurantId: string; integrationId: number }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    deactivateIntegrationSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    deactivateIntegrationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    // Reset error
    clearIntegrationError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchIntegrationsRequest,
  fetchIntegrationsSuccess,
  fetchIntegrationsFailure,
  activateIntegrationRequest,
  activateIntegrationSuccess,
  activateIntegrationFailure,
  deactivateIntegrationRequest,
  deactivateIntegrationSuccess,
  deactivateIntegrationFailure,
  clearIntegrationError,
} = integrationsSlice.actions;

export default integrationsSlice.reducer;
